import { marked, MarkedExtension } from 'marked';

export function githubAlertsExtension(): MarkedExtension {
  return {
    extensions: [{
      name: 'githubAlert',
      level: 'block',
      start(src: string) {
        return src.match(/^>\s*\[!/)?.index;
      },
      tokenizer(src: string) {
        // One alert = a `> [!TYPE]` line + ONLY blockquote-continuation lines
        // (each still starting with `>`). A truly blank line ends the alert, so
        // two adjacent alerts stay separate instead of the first swallowing the
        // blank gap and the next blockquote (which rendered the 2nd `[!TYPE]` as
        // literal text). Blank lines INSIDE an alert use `>` and still match.
        const rule = /^>\s*\[!(NOTE|TIP|IMPORTANT|WARNING|CAUTION)\][^\n]*(?:\n>\s*[^\n]*)*/i;
        const match = rule.exec(src);

        if (match) {
          const alertType = match[1].toUpperCase();
          // Extract the content after the alert marker
          const fullMatch = match[0];
          const lines = fullMatch.split('\n');
          const processedLines: string[] = [];
          
          // Process each line, removing the blockquote marker and alert syntax
          for (let i = 0; i < lines.length; i++) {
            const line = lines[i];
            if (i === 0) {
              // First line: remove the alert syntax
              const cleaned = line.replace(/^>\s*\[!(NOTE|TIP|IMPORTANT|WARNING|CAUTION)\]\s*/i, '');
              if (cleaned.trim()) {
                processedLines.push(cleaned);
              }
            } else {
              // Other lines: just remove the blockquote marker
              const cleaned = line.replace(/^>\s*/, '');
              processedLines.push(cleaned);
            }
          }

          return {
            type: 'githubAlert',
            raw: match[0],
            alertType: alertType,
            text: processedLines.join('\n').trim()
          };
        }
        return undefined;
      },
      renderer(token: any) {
        const type = token.alertType.toLowerCase();
        const icon = getMaterialIcon(type);
        const title = token.alertType.charAt(0).toUpperCase() + token.alertType.slice(1).toLowerCase();
        
        // Parse the content as markdown
        const parsedContent = marked.parse(token.text, { async: false });
        
        return `<div class="markdown-alert markdown-alert-${type}">
          <p class="markdown-alert-title">
            <span class="material-icons-outlined markdown-alert-icon">${icon}</span>
            <span>${title}</span>
          </p>
          <div class="markdown-alert-content">
            ${parsedContent}
          </div>
        </div>`;
      }
    }]
  };
}

function getMaterialIcon(type: string): string {
  const icons: Record<string, string> = {
    note: 'info',
    tip: 'lightbulb',
    important: 'priority_high',
    warning: 'warning',
    caution: 'report'
  };
  
  return icons[type] || icons.note;
}